import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import React, { Component } from "react";

class InfoDialog extends Component {
  render() {
    const { open, handleClose, message } = this.props;
    const customMessage =
      message ||
      "This ticket can not be edited due to change in contract stage.";
    return (
      <Dialog
        onClose={handleClose}
        open={open}
        fullWidth={true}
        maxWidth={"sm"}
        keepMounted
      >
        <DialogTitle className="dialog-title info-title">
          Information
        </DialogTitle>
        <DialogContent className="dialog-content">
          {customMessage}
        </DialogContent>
        <DialogActions className="action-buttons">
          <Button onClick={handleClose} color="primary">
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default InfoDialog;



// WEBPACK FOOTER //
// ./src/components/FormElement/InfoDialog.js